import {appApi} from "@services/api.service";
import {ReportWorker} from "@models/raport";
import moment from "moment";
import {ReportRowWorker} from "@app/reportPage/reportPage.component";
import {getCurrentNetworkStatus} from "@services/offlineSync.service";

type SickWorkerCheckResult = {
    workerId: string;
    hasActiveSickLeave: boolean;
};

const checkWorkersSickLeavesByDate = async (workers: (ReportRowWorker | ReportWorker)[], date: string): Promise<SickWorkerCheckResult[]> => {
    const networkStatus = await getCurrentNetworkStatus();

    if (!networkStatus) {
        return workers.map(worker => ({
            workerId: (worker as ReportRowWorker)?.personId ?? (worker as ReportWorker)?.id?.toString(),
            hasActiveSickLeave: worker.hasActiveSickLeave ?? false,
        }));
    }

    const workerIds = workers.map(worker => (worker as ReportRowWorker)?.personId ?? (worker as ReportWorker)?.id?.toString()).filter(Boolean);

    try {
        const response: any = await appApi.get('worker-sick-leave/check', {
            params: { workerIds, date: moment(date).format('YYYY-MM-DD') },
        });

        return response.data;
    } catch (error) {
        return workers.map(worker => ({
            workerId: (worker as ReportRowWorker)?.personId ?? (worker as ReportWorker)?.id?.toString(),
            hasActiveSickLeave: worker.hasActiveSickLeave ?? false,
        }));
    }
};

const checkWorkerHasActiveSickLeave = async (date: string, worker: ReportWorker | ReportRowWorker | null = null): Promise<boolean> => {
    if (!worker) {
        return false;
    }

    const results = await checkWorkersSickLeavesByDate([worker], date);

    return results[0]?.hasActiveSickLeave ?? false;
};

export {
    checkWorkersSickLeavesByDate,
    checkWorkerHasActiveSickLeave,
};
